module.exports = __webpack_public_path__ + "img/search-normal.1ddc59e5.svg";